import BaseApi from '~/api/base';
class ProjectsWorkSpace extends BaseApi {
    constructor() {
        super('/projects-workspace');
    }
}
const ProjectsWorkSpaceApi = new ProjectsWorkSpace();
export default ProjectsWorkSpaceApi;
